import { ChevronsUpDown } from "lucide-react"

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar"
import { UserInfo } from "@/components/user-info"
import { UserMenuContent } from "@/components/user-menu-content"
import { useCurrentContext } from "@/hooks/use-current-context"
import { useIsMobile } from "@/hooks/use-mobile"

/**
 * NavUser — sidebar-footer user dropdown.
 *
 * Reads `currentUser` from the OKS-5 shared-props contract via
 * `useCurrentContext()`. Renders nothing when `currentUser` is `null`.
 *
 * The trigger carries `data-testid="user-menu-trigger"` so demo + e2e
 * scenarios that need to drive the account menu (sign-out, settings link)
 * can locate it without depending on i18n'd visible labels (OKS-258).
 */
export function NavUser() {
  const { currentUser } = useCurrentContext()
  const { state } = useSidebar()
  const isMobile = useIsMobile()

  if (!currentUser) return null

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger
            render={
              <SidebarMenuButton
                size="lg"
                data-testid="user-menu-trigger"
                className="text-sidebar-accent-foreground data-[popup-open]:bg-sidebar-accent group"
              >
                <UserInfo user={currentUser} />
                <ChevronsUpDown className="ml-auto size-4" />
              </SidebarMenuButton>
            }
          />
          <DropdownMenuContent
            className="w-(--anchor-width) min-w-56 rounded-lg"
            align="end"
            side={
              isMobile ? "bottom" : state === "collapsed" ? "left" : "bottom"
            }
          >
            <UserMenuContent />
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
